import { createSlice } from "@reduxjs/toolkit";

const generateHash = (s) =>
  s.split("").reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);

const initialState = {
  id: Math.abs(
    generateHash(
      Math.random().toString(36).substring(7) + Date.now().toString()
    )
  ),
};

export const AppSlice = createSlice({
  name: "app",
  initialState,
});

export const { setSrc } = AppSlice.actions;
export default AppSlice.reducer;
